/*
 * DoubleScoreScreen
 * ==========
 */

import ScreenBase from '../ui/ScreenBase'

export default class DoubleScoreScreen extends ScreenBase {

  constructor (game, screens) {
    super(game, 'doubleScore');

    this.screens = screens;

    this.params = {
      'bg': [-3, 0],
      'title': [-2, -74],
      'subtitle': [-3, -40],
      'levelScore': [-1, 19],
      'x2Sign': [121, 40],
      'continue': [-2, 74]
    };

    this.bg = this.addSprite('bg', 'uiScreens', 'uiDoubleScorePanel.png');

    this.title = this.addText2('title', 'blue', 'Congratulations', 28);
    this.subtitle = this.addText2('subtitle', 'blue', 'Your level score doubled', 18);

    this.levelScore = this.addText2('levelScore', 'white', '13,136', 34);

    this.x2Sign = this.addSprite('x2Sign', 'uiScreens', 'x2Sign.png');

    this.continue = this.addTextButton2('continue', 'uiButtonContinue', 'Continue', this.continueClicked);

    this.setInputForAllButtons(false)
  }

  continueClicked (that) {
    // console.log('Continue')

    that.forceOutForAllButtons();
    that.screens.showScreen('gameSummary')
  }

  updateScore () {
    this.levelScore.setText(this.doubledPoints + '')
  }

  onShowStarted () {
    this.doubledPoints = GS.levelScore;
    this.updateScore();
    super.onShowStarted();

    GS.score += GS.levelScore;
    GS.levelScore += GS.levelScore;

    this.x2Sign.alpha = 0;
    this.x2Sign.scale.set(1.5)
  }

  onShowEnded () {
    super.onShowEnded();

    this.game.add.tween(this.x2Sign)
    .to({ alpha: 1}, 500)
    .start();

    this.game.add.tween(this.x2Sign.scale)
    .to({ x: 1, y: 1}, 500)
    .start();

    var doubledPointsBuff = this.doubledPoints;

    var tween = this.game.add.tween(this)
    .to({ doubledPoints: 2 * this.doubledPoints}, 1000)
    .delay(500)
    .start();

    tween.onUpdateCallback(function () {
      this.levelScore.setText(Math.round(this.doubledPoints) + '')
    }, this);

    this.game.time.events.add(1500, function () {
      this.doubledPoints = 2 * doubledPointsBuff;
      tween.stop();
      this.levelScore.setText(Math.round(this.doubledPoints) + '')
    }, this)
  }
}
